import React from 'react';
import { Card } from './ui/card';
import { Building2, Key, FileText, Calculator, PaintBucket, Lightbulb } from 'lucide-react';

export const Services = () => {
  const services = [
    {
      icon: Building2,
      title: 'Property Buying',
      description: 'Find your perfect home from our curated selection of premium properties across Coimbatore',
      features: ['Market Analysis', 'Property Tours', 'Negotiation Support']
    },
    {
      icon: Key,
      title: 'Property Selling',
      description: 'Get the best value for your property with our expert marketing and sales strategies',
      features: ['Property Valuation', 'Professional Photography', 'Marketing Strategy']
    },
    {
      icon: FileText,
      title: 'Legal Assistance',
      description: 'Complete documentation and legal support for hassle-free property transactions',
      features: ['Document Verification', 'Legal Compliance', 'Registration Support']
    },
    {
      icon: Calculator,
      title: 'Home Loan Assistance',
      description: 'Connect with leading banks for competitive home loan rates and quick approvals',
      features: ['Loan Comparison', 'Application Support', 'Best Rate Guarantee']
    },
    {
      icon: PaintBucket,
      title: 'Interior Design',
      description: 'Transform your space with our bespoke interior design solutions and execution',
      features: ['3D Visualization', 'Space Planning', 'Turnkey Solutions']
    },
    {
      icon: Lightbulb,
      title: 'Consultation',
      description: 'Expert advice on property investment, market trends, and design solutions',
      features: ['Investment Planning', 'Market Insights', 'Design Consultation']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-block bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Services
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0F1419] mb-6 playfair">
            Comprehensive Real Estate Solutions
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            From finding your dream property to designing your perfect home, we offer end-to-end services
            to make your real estate journey seamless and rewarding.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              key={index}
              className="p-8 hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#D4AF37]/30 smooth-hover group"
            >
              <div className="bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <service.icon className="w-8 h-8 text-[#D4AF37]" />
              </div>
              <h3 className="text-2xl font-bold text-[#0F1419] mb-4 playfair">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <div className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mr-3"></div>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};